const zhHans = {
  pleaseEnterUsername: "请输入用户名",
  cannotFriendYourself: "你不能向自己发送好友请求。",
  friendRequestSent: "好友请求已发送！",
  failedToSendRequest: "发送请求失败",
  linkCopied: "链接已复制到剪贴板！",
  backToInvites: "返回邀请",
  sendFriendRequestByUsername: "通过用户名发送好友请求",
  enterUsername: "输入用户名",
  send: "发送",
  yourInviteQrCode: "你的邀请二维码",
  inviteLink: "邀请链接",
  scanQrOrUseLink: "扫描此二维码或使用此链接发送好友请求",
  copyInviteLink: "复制邀请链接",
  goToItem: "前往项目",
  verificationEmailSent: "验证邮件已发送！请检查收件箱。",
  verificationEmailFailed: "发送验证邮件失败。请重试。",
  verifyYourEmail: "验证你的邮箱",
  verifyEmailInstructions: "请验证你的邮箱地址以访问账户。请检查收件箱中的验证链接。",
  sending: "发送中...",
  resendVerificationEmail: "重新发送验证邮件",
  login: "登录",
  register: "注册",
  home: "首页",
  calendar: "日历",
  friends: "好友",
  profile: "个人资料",
  logout: "退出登录",
  loading: "加载中...",
  language: "语言",
  calendarSelectPlaceSuggestion: "请从建议列表中选择地点，以便附加坐标。",
  calendarSelectDateAndTime: "请选择日期和时间。",
  calendarPositiveDuration: "请输入正数时长。",
  calendarFutureDateRequired: "活动日期和时间必须在未来。",
  calendarCreateEventFailed: "创建活动失败。请重试。",
  cancel: "取消",
  createNewEvent: "创建新活动",
  week: "周",
  month: "月",
  eventTitle: "标题",
  date: "日期",
  time: "时间",
  duration: "时长",
  endsAt: "结束于",
  place: "地点",
  searchForPlace: "搜索地点",
  placeSearchTip: "提示：开始输入并选择结果以附加坐标。",
  description: "描述",
  createEvent: "创建活动",
  today: "今天",
  previousMonth: "上个月",
  nextMonth: "下个月",
  previous: "上一项",
  next: "下一项",
  mondayShort: "周一",
  tuesdayShort: "周二",
  wednesdayShort: "周三",
  thursdayShort: "周四",
  fridayShort: "周五",
  saturdayShort: "周六",
  sundayShort: "周日",
  more: "更多",
  mustRespondWillBeforeReposting: "重新分享前必须选择“我会参加”",
  event: "活动",
  backToCalendar: "返回日历",
  addToGoogleCalendar: "添加到 Google 日历",
  when: "时间",
  where: "地点",
  openLocationInGoogleMaps: "在 Google 地图中打开位置",
  hosts: "组织者",
  yourResponse: "你的回复",
  currentResponse: "当前回复",
  response_will: "我会参加",
  response_might: "可能参加",
  response_wont: "不会参加",
  willRunIntoYou: "我会过去看看",
  mightDropBy: "我可能会过去",
  wontCome: "我不会来",
  repostToMyFriends: "分享给我的好友",
  responses: "回复",
  willAttend: "将参加",
  reposted: "已分享",
  mightAttend: "可能参加",
  cancelEvent: "取消活动",
  cancellationEmailNoticeBefore: "已确认参加的用户",
  cancellationEmailNoticeAfter: "将收到活动取消通知邮件。",
  optionalCancellationMessage: "发送给参与者的可选消息（最多 1000 个字符）",
  confirmCancelEvent: "确认取消活动",
  clear: "清除",
  confirmCancellation: "确认取消",
  confirmCancellationMessage: "确定要取消此活动吗？系统将通知已确认参加的用户并删除该活动。",
  eventCancelledNotified: "活动已取消。已通知",
  attendees: "位参与者",
  failedToCancelEvent: "取消活动失败",
  back: "返回",
  cancelled: "已取消",
  ok: "确定",
  forgotPassword: "忘记密码",
  email: "电子邮箱",
  passwordResetLinkSent: "如果账户存在，系统已发送密码重置链接。",
  passwordResetRequestFailed: "请求密码重置失败。",
  sendResetLink: "发送重置链接",
  addFriend: "添加好友",
  incomingRequests: "收到的请求",
  accept: "接受",
  deny: "拒绝",
  myFriends: "我的好友",
  noFriendsYet: "你还没有好友。快去添加一些吧！",
  seeProfile: "查看资料",
  noEventsToRespondTo: "没有需要回复的活动",
  allCaughtUp: "你已经查看完所有内容了。稍后再来查看好友的新活动。",
  events: "活动",
  unknown: "未知",
  noDescriptionProvided: "未提供描述。",
  will: "参加",
  maybe: "可能",
  wont: "不参加",
  userNotFound: "未找到用户",
  friendRequestSentSuccessfully: "好友请求发送成功！",
  friendInvitation: "好友邀请",
  sendFriendRequest: "发送好友请求",
  loginToSendFriendRequest: "请先登录后发送好友请求",
  chooseLanguage: "选择语言",
  invalidCredentials: "凭据无效，请重试。",
  username: "用户名",
  password: "密码",
  forgotPasswordQuestion: "忘记密码？",
  dontHaveAccount: "还没有账号？",
  registerHere: "点击注册",
  invalidProfilePhotoType: "无效的文件类型。请上传 JPEG、PNG、GIF 或 WebP 图片。",
  invalidFileExtension: "无效的文件扩展名",
  allowedExtensions: "允许的格式",
  fileTooLarge: "文件过大",
  maximumFileSize: "最大值",
  profilePhotoRemoved: "头像已删除。",
  failedToRemoveProfilePhoto: "删除头像失败",
  profileUpdatedSuccessfully: "资料更新成功！",
  failedToUpdateProfile: "更新资料失败",
  privateEmailExplanation: "只有你可以看到自己的邮箱地址，以避免平台外的骚扰信息",
  yourEmailIsPrivate: "你的邮箱是私密的。",
  profilePhoto: "头像",
  removePhoto: "删除头像",
  firstName: "名字",
  lastName: "姓氏",
  tellPeopleAboutYourself: "介绍一下自己",
  whereToContactMe: "联系方式",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "保存",
  notSet: "未设置",
  editProfile: "编辑资料",
  imageToCrop: "裁剪图片",
  zoom: "缩放",
  usePhoto: "使用照片",
  name: "姓名",
  whereToContact: "联系方式",
  removeFriendship: "删除好友",
  confirmRemoveFriend: "确认删除好友",
  confirmRemoveFriendBefore: "你确定要将",
  confirmRemoveFriendAfter: "从好友列表中删除吗？",
  friendRemoved: "好友已删除。",
  failedToRemoveFriend: "删除好友失败。",
  confirmRemove: "确认删除",
  error: "错误",
  removed: "已删除",
  passwordsDoNotMatch: "两次输入的密码不一致",
  registrationFailed: "注册失败，请重试。",
  confirmPassword: "确认密码",
  alreadyHaveAccount: "已有账号？",
  loginHere: "点击登录",
  passwordResetSuccessfully: "密码重置成功。",
  failedToResetPassword: "密码重置失败。",
  resetPassword: "重置密码",
  newPassword: "新密码",
  confirmNewPassword: "确认新密码",
  setNewPassword: "设置新密码",
  emailVerifiedSuccessfully: "邮箱验证成功！",
  emailVerificationFailed: "验证失败，链接可能无效或已过期。",
  verifying: "验证中...",
  verified: "已验证！",
  redirectingToHome: "正在跳转到首页...",
  verificationFailed: "验证失败",
  goToHome: "返回首页",
  about: "关于",
  aboutConceptTitle: "理念",
  aboutCreatorIntroduction: "你好，我是Crypt0，一名攀岩者，也是Run Into Me的创建者。",
  aboutCreatorStory: "我创建这个网站，是因为我喜欢社交，在攀爬间隙总会和其他攀岩者聊天。结果，我存了太多电话号码，也花了太多空闲时间安排攀岩活动。",
  aboutPlanningProblem: "我厌倦了规划活动并逐个联系朋友。我希望能同时告诉大家我会在何时何地攀岩，而不必正式邀请他们。",
  aboutDeveloperSolution: "这时我想起自己是开发者，可以亲自做一个解决方案。",
  aboutWelcome: "欢迎使用Run Into Me。它可以让朋友知道你何时进行他们可轻松加入的活动。",
  aboutCallToAction: "下次计划一项可以独自完成但一起更有趣的活动时，就发布在这里让朋友看到吧！",
  aboutTutorialTitle: "教程",
  aboutCalendarCreateEvent: "日历页面也可用于创建新活动。",
  aboutEventColorsIntroduction: "活动颜色表示你的参与状态：",
  aboutColorGold: "金色",
  aboutColorGoldDescription: "你是此活动的组织者。",
  aboutColorGreen: "绿色",
  aboutColorGreenDescription: "你将参加此活动。",
  aboutColorOrange: "橙色",
  aboutColorOrangeDescription: "你回答了“可能”。",
  aboutColorBlue: "蓝色",
  aboutColorBlueDescription: "你尚未回答。",
  aboutColorGray: "灰色",
  aboutColorGrayDescription: "你已拒绝邀请。",
  aboutCalendarEventDetails: "点击活动可查看更多信息并作出回应。",
  aboutFriendPageTitle: "好友页面",
  aboutFriendPageDescription: "输入用户名或发送邀请链接／二维码即可添加好友。",
  aboutHomePageTitle: "主页",
  aboutHomePageDescription: "浏览好友即将举行的活动并告知他们你是否参加。",
  aboutRepostScreenTitle: "转发页面",
  aboutGoogleCalendarDescription: "使用此按钮将活动添加到Google日历。",
  aboutRepostDescription: "确认参加好友的活动后，你可以将其转发给自己的好友。",
};

export default zhHans;